import React from 'react';
import { Edit, Trash2, Shield, Users, Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Pagination from '../../Pagination';

const RolesList = ({
  roles,
  loading,
  selectedRoles,
  onSelectRole,
  onSelectAll,
  onOpenModal,
  onOpenDeleteModal,
  currentPage,
  totalPages,
  setCurrentPage
}) => {
  const navigate = useNavigate();

  const handleEditRole = (role) => {
    navigate(`/roles/${role.id}/edit`);
  };

  if (loading) {
    return (
      <div className="bg-white shadow-sm rounded-lg overflow-hidden">
        <div className="flex justify-center items-center h-64">
          <div className="flex flex-col items-center">
            <Loader2 className="h-8 w-8 text-[#202654] animate-spin" />
            <span className="mt-2 text-sm text-gray-500">Chargement des rôles...</span>
          </div>
        </div>
      </div>
    );
  }

  if (roles.length === 0) {
    return (
      <div className="bg-white shadow-sm rounded-lg overflow-hidden">
        <div className="text-center py-12">
          <Shield className="mx-auto h-12 w-12 text-gray-400" />
          <h3 className="mt-2 text-sm font-medium text-gray-900">Aucun rôle</h3>
          <p className="mt-1 text-sm text-gray-500">
            Commencez par créer un nouveau rôle.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white shadow-sm rounded-lg overflow-hidden">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
        {roles.map((role) => (
          <div key={role.id} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={selectedRoles.includes(role.id)}
                  onChange={() => onSelectRole(role.id)}
                  className="h-4 w-4 text-[#202654] focus:ring-[#202654] border-gray-300 rounded mr-3"
                />
                <div className="bg-blue-100 p-2 rounded-lg mr-3">
                  <Shield className="h-6 w-6 text-[#202654]" />
                </div>
                <div>
                  <h3 className="text-lg font-medium text-gray-900">{role.name}</h3>
                  <p className="text-sm text-gray-500">
                    {role.permissions?.length || 0} permission(s)
                  </p>
                </div>
              </div>
              <div className="flex space-x-2">
                <button
                  onClick={() => handleEditRole(role)}
                  className="text-[#202654] hover:text-[#1a1f45] p-1"
                  title="Modifier"
                >
                  <Edit className="h-4 w-4" />
                </button>
                <button
                  onClick={() => onOpenDeleteModal(role)}
                  className="text-red-600 hover:text-red-900 p-1"
                  title="Supprimer"
                >
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            </div>
            
            <div className="border-t pt-4">
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-500">Utilisateurs assignés</span>
                <div className="flex items-center">
                  <Users className="h-4 w-4 text-gray-400 mr-1" />
                  <span className="font-medium text-gray-900">
                    {role.user_count || 0}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* Pagination */}
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      )}
    </div>
  );
};

export default RolesList; 